
import ConfirmationOverlay from '@/components/ConfirmationOverlay.vue';
import { defineComponent, PropType } from 'vue';
import { ActionTypes } from '@/store/actionTypes';
import { AssociationType } from '@/types/AssociationType';

export default defineComponent({
    components: {
        ConfirmationOverlay,
    },
    props: {
        association: {
            type: String as PropType<AssociationType>,
            required: true,
        },
    },
    computed: {
        confirmationShown(): boolean {
            return this.$route.query.confirmation === 'gobackconfirmation';
        },
    },
    methods: {
        goBack(): void {
            this.$store.dispatch(
                ActionTypes.CLEAR_TRAILER_ASSESSMENT,
                undefined
            );
            const driver = this.$store.getters.getDriver;
            const truck = this.$store.getters.getTruck;

            this.$router.push({
                name: 'DriverLanding',
                params: {
                    company: driver?.company,
                    truckId: truck?.id,
                    driverCode: driver?.driverCode,
                },
            });
        },
        returnToTrailerAssessment(): void {
            this.$store.dispatch(ActionTypes.CLEAR_QUERY_PARAM_AND_ROUTE, {
                routeToName: 'TrailerAssessment',
                omitParam: 'confirmation',
            });
        },
    },
});
